module.exports = __webpack_public_path__ + "img/waves-1.8f59348e.webp";